import { FunctionComponent } from "react";
import { useSelector } from "react-redux";

import Head from "rivals/components/shared/Head";
import { getSelectedSite } from "rivals/redux/rails/selectors";
import strings from "./strings";

const ForecastHead: FunctionComponent = () => {
  const selectedSite = useSelector(getSelectedSite);
  const title = `${selectedSite?.friendlyName} ${
    selectedSite?.nickname ? selectedSite?.nickname : ""
  } ${strings.forecastTitle}`;

  return <Head ogImage={""} ogUrl={""} title={title} />;
};

export default ForecastHead;
